export default __webpack_public_path__ + "static/media/contruction-illustration.fd61f0ce.svg";